/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const WfespPluginConfR = t.interface({
  id_bean: t.string,

  id_serv_plugin: t.string,

  pag_const_string_profile: t.string,

  pag_rpt_xpath_profile: t.string,

  pag_soap_rule_profile: t.string
});

// optional attributes
const WfespPluginConfO = t.partial({});

export const WfespPluginConf = t.intersection(
  [WfespPluginConfR, WfespPluginConfO],
  "WfespPluginConf"
);

export type WfespPluginConf = t.TypeOf<typeof WfespPluginConf>;
